import { render, staticRenderFns } from "./ClaimNotifications.vue?vue&type=template&id=349767ee&scoped=true&"
import script from "./ClaimNotifications.vue?vue&type=script&lang=js&"
export * from "./ClaimNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ClaimNotifications.vue?vue&type=style&index=0&id=349767ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349767ee",
  null
  
)

export default component.exports